import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { addressApi } from "shared/hooks/addressApi";
import { backendApi } from "shared/hooks/backend.api";
import { orderApi } from "shared/hooks/orderApi";
import { routeApi } from "shared/hooks/routeApi";
import { productApi } from "shared/hooks/productApi";
import { statusApi } from "shared/hooks/statusApi";
import { storeDocumentApi } from "shared/hooks/storeDocumentApi";
import { visitApi } from "shared/hooks/visitApi";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import visitReducer from "entities/visit/store";
import orderReducer from "entities/order/store";
import productReducer from "entities/product/store";
import storeReducer from "entities/store/store";
import serviceReducer from "entities/service/store";
import expenseReducer from "entities/investment/store";
import spaceReducer from "entities/space/store";
import snackReducer from "entities/snack/store";
import permissionReducer from "entities/permission/store";
import { userApi } from "shared/hooks/userApi";
import { carApi } from "shared/hooks/carApi";
import { templateApi } from "shared/hooks/templateApi";
import { machineApi } from "shared/hooks/machineApi";
import { serviceApi } from "shared/hooks/serviceApi";
import { paymentApi } from "shared/hooks/paymentApi";
import { eventApi } from "shared/hooks/eventApi";
export const store = configureStore({
  reducer: {
    [backendApi.reducerPath]: backendApi.reducer,
    visit: visitReducer,
    store: storeReducer,
    product: productReducer,
    snack: snackReducer,
    order: orderReducer,
    service: serviceReducer,
    expense: expenseReducer,
    space: spaceReducer,
    permission: permissionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      backendApi.middleware,
      addressApi.middleware,
      productApi.middleware,
      orderApi.middleware,
      statusApi.middleware,
      visitApi.middleware,
      storeDocumentApi.middleware,
      userApi.middleware,
      routeApi.middleware,
      carApi.middleware,
      eventApi.middleware,
      templateApi.middleware,
      machineApi.middleware,
      serviceApi.middleware,
      paymentApi.middleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
